module.exports = __webpack_public_path__ + "files/22f5538e33bc56330c3147c61f5f8949.png";


//////////////////
// WEBPACK FOOTER
// ./images/favicon/apple-touch-icon-76x76.png
// module id = 744
// module chunks = 27